import { render, staticRenderFns } from "./DiagnosisForm.vue?vue&type=template&id=2ebaa13f&scoped=true&"
import script from "./DiagnosisForm.vue?vue&type=script&lang=ts&"
export * from "./DiagnosisForm.vue?vue&type=script&lang=ts&"
import style0 from "./DiagnosisForm.vue?vue&type=style&index=0&id=2ebaa13f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebaa13f",
  null
  
)

export default component.exports